import { takeEvery, call, put, select } from 'redux-saga/effects';
import {
  sendForm,
  requestFinished,
  setErrors,
  selectFormBody,
  clearAllErrors,
  changeMessage
} from '../../../../common/reducers/forms/resetPasswordForm';

import { timeoutCall } from '../../../../../../utils/sagaHalper';
import UserService from '../../../../services/UserService';

function* changePassword(reducerName, action) {
  const formBody = yield select(selectFormBody, reducerName);
  try {
    yield put(clearAllErrors(reducerName));
    const response = yield call(
      timeoutCall,
      UserService.changePasswordByToken,
      action.payload.token,
      formBody
    );
    if (response) {
      if (response.status === 422) {
        yield put(setErrors(reducerName, response.data));
      } else if (response.status === 200) {
        yield put(changeMessage(reducerName, response.data.message));
      }
    }
    yield put(
      requestFinished(reducerName, response.status, response.status === 200)
    );
  } catch (error) {
    yield put(requestFinished(reducerName));
  }
}

export default function getSaga(reducerName) {
  return [takeEvery(sendForm(reducerName).type, changePassword, reducerName)];
}



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/users/reducers/static/forms/sagas/resetPasswordFormSaga.js